import ReactPaginate from 'react-paginate';
import { ChevronLeft, ChevronRight } from 'lucide-react'
interface PaginationProps {
  pageCount: number;
  currentPage: number;
  onPageChange: (selected: number) => void;
}

export const Pagination: React.FC<PaginationProps> = ({ pageCount, currentPage, onPageChange }) => {
  return (
     <div className="flex justify-center mt-8">
                  <ReactPaginate
                  previousLabel={
                      <span className="flex items-center gap-1">
                        <ChevronLeft className="h-4 w-4" />
                        <span className="hidden sm:inline">Назад</span>
                      </span>
                    }
                    nextLabel={
                      <span className="flex items-center gap-1">
                        <span className="hidden sm:inline">Вперед</span>
                        <ChevronRight className="h-4 w-4" />
                      </span>
                    }
                    breakLabel="..."
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    onPageChange={({ selected }) => onPageChange(selected)}
                    forcePage={currentPage} // react-paginate uses 0-indexed pages
                    containerClassName="flex items-center gap-2"
                    pageClassName=""
                    pageLinkClassName="min-w-[40px] h-10 px-3 py-2 text-sm font-medium border border-gray-300 bg-white text-gray-700 rounded-md hover:bg-[#ed8510] hover:text-white hover:border-[#ed8510] transition-colors duration-200 flex items-center justify-center"
                    activeLinkClassName="!bg-white bg-[#ed8510] !text-white border-[#ed8510]"
                    previousClassName=""
                    previousLinkClassName="h-10 px-3 py-2 text-sm font-medium border border-gray-300 bg-white text-gray-700 rounded-md hover:bg-[#ed8510] hover:text-white hover:border-[#ed8510] transition-colors duration-200 flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:text-gray-700 disabled:hover:border-gray-300"
                    nextClassName=""
                    nextLinkClassName="h-10 px-3 py-2 text-sm font-medium border border-gray-300 bg-white text-gray-700 rounded-md hover:bg-[#ed8510] hover:text-white hover:border-[#ed8510] transition-colors duration-200 flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:text-gray-700 disabled:hover:border-gray-300"
                    breakClassName=""
                    breakLinkClassName="h-10 px-3 py-2 text-sm text-gray-500 flex items-center justify-center"
                    disabledClassName="opacity-50 cursor-not-allowed [&>a]:hover:bg-white [&>a]:hover:text-gray-700 [&>a]:hover:border-gray-300"
                  />
                </div>
  );
};